// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.request-correction-form,
.request-correction-form * {
    box-sizing: border-box;
}

.request-correction-form {
    width: 100%;
    padding: 0 10px 10px;
}

.request-correction-form .mb-3 {
    margin-bottom: 14px !important;
}

.request-correction-form label {
    display: block;
    margin-bottom: 6px;
    color: #34495e;
    font-weight: 600;
}

.request-correction-form .form-control,
.request-correction-form .form-select {
    width: 100%;
    min-height: calc(1.5em + 0.75rem + 2px);
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.request-correction-form textarea.form-control {
    min-height: 90px;
    resize: vertical;
}

.request-correction-contract {
    display: grid;
    grid-template-columns: minmax(280px, 1fr) minmax(320px, 1fr);
    gap: 20px;
    align-items: stretch;
    max-width: none;
    margin-bottom: 24px;
    padding: 18px;
    border: 1px solid #e1e8ee;
    border-radius: 10px;
    background: #f8fafb;
}

.request-correction-contract .mb-3 {
    margin-bottom: 0 !important;
}

.request-correction-contract .form-control {
    min-height: 48px;
    background: #fff;
}

.request-correction-loading {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    color: #60758a;
    font-size: 0.9rem;
}

.request-correction-info {
    display: flex;
    align-items: center;
    gap: 10px;
    min-height: 78px;
    margin: 0;
    padding: 12px 14px;
    border: 1px solid #cfe2f0;
    border-radius: 8px;
    background: #f2f8fc;
    color: #506b82;
    font-size: 0.86rem;
    line-height: 1.4;
}

.request-correction-info i {
    flex: 0 0 auto;
    color: #006699;
    font-size: 1.35rem;
}

.request-correction-form > .row {
    --bs-gutter-x: 24px;
}

.request-correction-actions {
    display: flex;
    justify-content: center;
    margin-top: 18px;
}

.request-correction-primary,
.request-correction-primary:hover,
.request-correction-primary:focus,
.request-correction-primary:active {
    min-width: 150px;
    padding: 10px 20px;
    border-color: #006699 !important;
    border-radius: 4px;
    background: #006699 !important;
    color: #fff !important;
}

@media (max-width: 767px) {
    .request-correction-contract {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
        padding: 14px;
    }

    .request-correction-info { min-height: auto; }
}
`, "",{"version":3,"sources":["webpack://./src/Pages/Css/correccionSolicitud.css"],"names":[],"mappings":"AAAA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;IACX,uCAAuC;IACvC,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,oBAAoB;IACpB,eAAe;IACf,mBAAmB;IACnB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;;IAII,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;QACT,aAAa;IACjB;;IAEA,2BAA2B,gBAAgB,EAAE;AACjD","sourcesContent":[".request-correction-form,\n.request-correction-form * {\n    box-sizing: border-box;\n}\n\n.request-correction-form {\n    width: 100%;\n    padding: 0 10px 10px;\n}\n\n.request-correction-form .mb-3 {\n    margin-bottom: 14px !important;\n}\n\n.request-correction-form label {\n    display: block;\n    margin-bottom: 6px;\n    color: #34495e;\n    font-weight: 600;\n}\n\n.request-correction-form .form-control,\n.request-correction-form .form-select {\n    width: 100%;\n    min-height: calc(1.5em + 0.75rem + 2px);\n    padding: 8px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.request-correction-form textarea.form-control {\n    min-height: 90px;\n    resize: vertical;\n}\n\n.request-correction-contract {\n    display: grid;\n    grid-template-columns: minmax(280px, 1fr) minmax(320px, 1fr);\n    gap: 20px;\n    align-items: stretch;\n    max-width: none;\n    margin-bottom: 24px;\n    padding: 18px;\n    border: 1px solid #e1e8ee;\n    border-radius: 10px;\n    background: #f8fafb;\n}\n\n.request-correction-contract .mb-3 {\n    margin-bottom: 0 !important;\n}\n\n.request-correction-contract .form-control {\n    min-height: 48px;\n    background: #fff;\n}\n\n.request-correction-loading {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    color: #60758a;\n    font-size: 0.9rem;\n}\n\n.request-correction-info {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    min-height: 78px;\n    margin: 0;\n    padding: 12px 14px;\n    border: 1px solid #cfe2f0;\n    border-radius: 8px;\n    background: #f2f8fc;\n    color: #506b82;\n    font-size: 0.86rem;\n    line-height: 1.4;\n}\n\n.request-correction-info i {\n    flex: 0 0 auto;\n    color: #006699;\n    font-size: 1.35rem;\n}\n\n.request-correction-form > .row {\n    --bs-gutter-x: 24px;\n}\n\n.request-correction-actions {\n    display: flex;\n    justify-content: center;\n    margin-top: 18px;\n}\n\n.request-correction-primary,\n.request-correction-primary:hover,\n.request-correction-primary:focus,\n.request-correction-primary:active {\n    min-width: 150px;\n    padding: 10px 20px;\n    border-color: #006699 !important;\n    border-radius: 4px;\n    background: #006699 !important;\n    color: #fff !important;\n}\n\n@media (max-width: 767px) {\n    .request-correction-contract {\n        display: flex;\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n        padding: 14px;\n    }\n\n    .request-correction-info { min-height: auto; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
